import media from './mediaReducer';
import widgetInfo from './widgetInfo';

const root = {
	media,
	widgetInfo
};

export default root;
